module.exports = __webpack_public_path__ + "img/TapOutXT.eeaa45be.jpg";